import { useState } from 'react';
import StreamList from '../../components/admin/streams/StreamList';
import StreamForm from '../../components/admin/streams/StreamForm';
import { getAllFunds } from '../../services/firestoreService';
import Button from '../../components/shared/UI/Button';
import { useEffect } from 'react';

export default function StreamsPage() {
  const [view, setView] = useState('list');
  const [selectedStream, setSelectedStream] = useState(null);
  const [selectedFundId, setSelectedFundId] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);
  const [funds, setFunds] = useState([]);

  useEffect(() => {
    getAllFunds().then(setFunds);
  }, []);

  function fundName(fid) {
    return funds.find(f => f.id === fid)?.name || fid;
  }

  function handleSaved() {
    setView('list');
    setSelectedStream(null);
    setRefreshKey(k => k + 1);
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Fund Streams</h1>
          <p>Configure streams for multi-strategy funds.</p>
        </div>
      </div>

      {view === 'list' && (
        <StreamList
          key={refreshKey}
          onAdd={(fundId) => { setSelectedFundId(fundId); setSelectedStream(null); setView('add'); }}
          onEdit={(stream, fundId) => { setSelectedStream(stream); setSelectedFundId(fundId); setView('edit'); }}
        />
      )}

      {(view === 'add' || view === 'edit') && (
        <div>
          <div style={{ marginBottom: 20 }}>
            <Button variant="ghost" onClick={() => { setView('list'); setSelectedStream(null); }}>
              ← Back to Streams
            </Button>
          </div>
          <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 20 }}>
            {view === 'add' ? 'Add New Stream' : `Edit: ${selectedStream?.name}`}
          </h2>
          <StreamForm
            stream={view === 'edit' ? selectedStream : null}
            fundId={selectedFundId}
            fundName={fundName(selectedFundId)}
            onSaved={handleSaved}
            onCancel={() => { setView('list'); setSelectedStream(null); }}
          />
        </div>
      )}
    </div>
  );
}
